import React from "react"
import clsx from 'clsx'
import CustomerSelect from "../../Selects/CustomerSelect"
import CreditCardForm from '../../BookingFlow/CreditCardForm';
import DataTable from "../../DataTable/DataTable"
import DateHelper from '../../DateHelper/DateHelper';
import ErrorHelper from "../../Errors/ErrorHelper";




class ReassignCustomerGeneral extends React.Component {
  constructor(props) {
    super(props)
    this.onChangeCardInput = this.onChangeCardInput.bind(this)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "reassign-customer-general",
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="reassign-customer-general">
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{I18n.t('customer')}</label>
            <CustomerSelect customer={this.props.customer} onChange={this.props.onChangeCustomer} reservation_segment={this.props.reservation_segments.first} error={(this.props.errors && this.props.errors.customer && this.props.errors.customer.length) ? true : false}/>
            <div className={"flexed new-payment-customer-wrapper " + (this.props.errors && this.props.errors.customer && this.props.errors.customer.length ? 'with-errors' : '')}>
              {this.props.errors ? ErrorHelper.renderFieldErrors('customer', this.props.errors) : null}
              <a href="/admin/customers/new" data-fullscreen="true" data-nested="true" className="btn btn-link btn-xs modal-iframe new-customer-button">{I18n.t('new_customer')}</a>
            </div>
          </div>
          <div className="col-md-9">
            {this.renderCustomerCards()}
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-body container">
            <div className="table-wrap-panel">
              <DataTable
               endpoint = {this.props.reassign_customer_data_table_path}
               ids ={this.props.reservation_segments.map((reservation_segment) => {return reservation_segment.id})}
               no_data_text = {I18n.t('none')}
               currency_unit = {I18n.t('number.currency.format.unit')}
               delimiter = {I18n.t('number.currency.format.delimiter')}
               separator = {I18n.t('number.currency.format.separator')}
               date_format = {this.props.date_format}
               time_format = {this.props.time_format}
               read_only = {this.props.read_only} />
            </div>
          </div>
        </div>
      </div>
    )
  };

  onUseThisCard(id) {
    this.props.setCard(id);
  };

  onChangeCardInput(e) {
    var card = this.props.card ? Object.assign({}, this.props.card) : { save_card: true }

    if (e.target.name === 'save_card') {
      card[e.target.name] = e.target.checked;
    } else {
      card[e.target.name] = e.target.value;
    };

    this.props.changeCardInput(card);
  };

  onResetCardElement = () => {
    this.props.resetCardDetails();
  };

  renderCustomerCards() {
    if (this.props.customer) {
      if (this.props.payment_method && this.props.payment_method.payment_token) {
        return (
          <div className={ErrorHelper.renderFieldClasses('reservation', this.props.errors, 'PaymentMethod  PaymentCards')} >
            <p><a href="#" onClick={() => this.props.onToggleCustomerCardForm()} >{I18n.t('remove')}</a></p>
            <label className="saved-card-label flexed align-items-center">
              <span className={"cc-icon-span credit-card-icon small " + this.props.payment_method.payment_token.card.brand}></span>
              <span className="cc-details-span">{I18n.t('ending_in').toLowerCase()} <strong>{this.props.payment_method.payment_token.card.last4}</strong> {I18n.t('exp')} <strong>{this.props.payment_method.payment_token.card.exp_month}/{this.props.payment_method.payment_token.card.exp_year}</strong> </span>
            </label>
          </div>
        )
      } else if (!this.props.displayNewCustomerCard && this.props.customer.cards && this.props.customer.cards.length ){
        var cards = this.props.customer.cards.map((card) => {
          return (
            <div className={"card well " + (this.props.card_id == card.id ? 'card-selected' : '')} key={card.id} >
              <div className="flexed card-input-detail-wrapper">
                <input className="saved-card-input" type="radio" name="card_id" value={card.id} checked={this.props.card_id == card.id} onChange={() => this.onUseThisCard(card.id)} />
                <label className="saved-card-label flexed align-items-center">
                  <span className={"cc-icon-span credit-card-icon small " + card.brand}></span>
                  <span className="cc-details-span">{I18n.t('ending_in').toLowerCase()} <strong>{card.last_4}</strong> {I18n.t('exp')} <strong>{card.month}/{card.year}</strong> {I18n.t('last_payment')} <strong>{card.last_payment ? DateHelper.printDateToScreen(card.last_payment.processed_at, DateHelper.rubyToDateFNS(this.props.date_format)) : I18n.t('none')}</strong></span>
                </label>
              </div>
            </div>
          );
        });
        return (
          <div className={ErrorHelper.renderFieldClasses('reservation', this.props.errors, 'PaymentMethod  PaymentCards')}>
            <p><a href="#" onClick={() => !this.props.displayNewCustomerCard ? this.props.onToggleCustomerCardForm() : null}>{I18n.t(!this.props.displayNewCustomerCard ? 'add_new_card' : 'use_existing_cards')}</a></p>
            <div className="cards">{cards}</div>
          </div>
        );
      }  else if (this.props.displayNewCustomerCard || (!this.props.card_id && this.props.customer && this.props.customer.id && this.props.customer.cards && this.props.customer.cards.length)){
        return(
          <div className={ErrorHelper.renderFieldClasses('reservation', this.props.errors, 'PaymentMethod  PaymentCards')}>
            {<p><a href="#" onClick={() => !this.props.card_id ? this.props.onToggleCustomerCardForm() : null}>{I18n.t(!this.props.card_id ? 'use_existing_cards' : 'add_new_card')}</a></p>}
            <div className="col-md-9 card-form-wrapper">

              <CreditCardForm
                card={this.props.card}
                saveCard={true}
                lockSave={this.props.lockSave}
                customer={this.props.customer}
                onChangeCardInput={this.onChangeCardInput}
                ReservationBuilderCustomerCards={this.props.disableCardNameInput}
                disableNameOnCard={this.props.disableCardNameInput}
                displayCardResetButton={this.props.displayCardResetButton}
                onResetCardElement={this.onResetCardElement}
                hasClassErrors={(string) => {
                  return this.props.errors && this.props.errors['card'] ? true : false;
                }}
              />
            </div>
          </div>
        )
      } else if (this.props.customer.first_name && this.props.customer.last_name && this.props.customer.email) {
        return (
          <div className={ErrorHelper.renderFieldClasses('reservation', this.props.errors, 'PaymentMethod  PaymentCards')}>
            <div className="col-md-9 card-form-wrapper">
              <CreditCardForm
                card={this.props.card ? this.props.card : { save_card: true, payment_type: 'card', cash_drawer: '' }}
                saveCard={true}
                lockSave={this.props.lockSave}
                customer={this.props.customer}
                onChangeCardInput={this.onChangeCardInput}
                ReservationBuilder={true}
                ReservationBuilderCustomerCards={this.props.disableCardNameInput}
                disableNameOnCard={this.props.disableCardNameInput}
                displayCardResetButton={this.props.displayCardResetButton}
                onResetCardElement={this.onResetCardElement}
                hasClassErrors={(string) => {
                  return this.props.errors && this.props.errors['card'] ? true : false;
                }}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div className="jumbotron" style={{ marginBottom: 0 }}>
            <p className="text-center" style={{ marginBottom: 0 }}>{I18n.t('select_customer_to_set_cards')}</p>
          </div>
        );
      };
    } else {
      return (
        <div className="jumbotron" style={{ marginBottom: 0 }}>
          <p className="text-center" style={{ marginBottom: 0 }}>{I18n.t('select_customer_to_set_cards')}</p>
        </div>
      );
    };
  };
}

export default ReassignCustomerGeneral
